
angular.module('bmsApp.crm.customer').controller('CustomerViewContactsCtrl', [
	'$scope',
	'$ngBootbox',
	'ngTableParams',
	'ContactSvc', function (
		$scope,
		$ngBootbox,
		ngTableParams,
		ContactSvc) {

		$scope.tabs.contacts.select = function () {
			if (angular.isUndefined($scope.additionalContacts)) {
				$scope.tabs.contacts.loadAdditional();
			}
		};

		$scope.tabs.contacts.loadAdditional = function () {
			if (angular.isUndefined($scope.additionalContacts)) {
				$scope.additionalContacts = new ngTableParams(angular.extend({
					page: 1, // show first page
					count: $scope.config.tabbedTable.params.count, // count per page
					sorting: {
						display_name: 'asc' // initial sorting
					}
				}), {
					total: 0, // length of data
					counts: $scope.config.tabbedTable.settings.counts, // available page counts
					getData: function ($defer, params) {
						ContactSvc.byCustomer($scope.customerId, false, params.$params)
							.then(function (response) {
								$scope.contactTotal = response.data.contact_total_count;
								params.total(response.data.contact_filtered_count);
								$defer.resolve(response.data.contact_collection);
							});
					}
				});
			}
			else {
				$scope.additionalContacts.reload();
			}
		};

		$scope.tabs.contacts.showForm = function (contact) {
			contact.customer = {
				id: $scope.customerId
			};
			ContactSvc.showSaveModal(contact)
				.then(function () {
					$scope.setActiveTab('contacts');
					$scope.tabs.contacts.loadAdditional();
				});
		};

		$scope.tabs.contacts.confirmPrimary = function (contact) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					ContactSvc.setPrimary(contact)
						.then(function () {
							$scope.loadCustomer();
							$scope.tabs.contacts.loadAdditional();
						});
				});
		};

	}]);